import $ from 'jquery';
window.jQuery = $;
require('lightslider');

delete window.jQuery;

const $slider = $('.js_slider');

const init = () => {
    $slider.lightSlider({
        item: 1,
        speed: 1000,
        pager: false
    });
};

export default init();
